import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=fb58b1fe&scoped=true&"
import script from "./FloatButton.vue?vue&type=script&lang=js&"
export * from "./FloatButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=fb58b1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb58b1fe",
  null
  
)

export default component.exports